import th from './th'
import mk from './mk'
export default {
	th,
	mk,
}
